import { render, staticRenderFns } from "./CtrEdit.vue?vue&type=template&id=0ed9a873"
import script from "./CtrEdit.vue?vue&type=script&lang=js"
export * from "./CtrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports